module.exports = __webpack_public_path__ + "media/images/partner/pic_6@2x-f79384bbe2b5a1c6ecad8b89d292714e.png";